<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'

const isShown = defineModel<boolean>()

const { t } = useI18n()

const { createSnackbar } = useWidgetStore()
const userStore = useUserStore()
const { isDirectSign } = storeToRefs(useDirectSignStore())

const { userRepository, directUserRepository } = useLegacyApi()
const { handleIdentExists } = useIdentAvailability()

const isLoading = ref(false)

const connectIdAustria = async () => {
  isLoading.value = true

  try {
    // FIXME: Careful, the endpoints for direct signers and regular user do not behave consistently
    if (isDirectSign.value) {
      await directUserRepository.update({
        tspPreferenceQesEidas: 'atrust',
      })
    } else {
      await userRepository.updateAttributes({
        tspPreferenceQesEidas: 'atrust',
      })
    }
    await userStore.fetchUser()
    handleIdentExists()
  } catch {
    createSnackbar({
      message: t('global.general_error'),
    })
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <v-dialog v-model="isShown" max-width="510">
    <v-card data-cy="connect_id_austria_dialog">
      <v-card-title class="text-h5">
        {{ t('dialog.connect_id_austria.title') }}
      </v-card-title>
      <v-card-text>
        {{ t('dialog.connect_id_austria.information') }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <skr-button type="secondary" size="xl" color="info" @click="isShown = false">
          {{ t('global.no_thanks') }}
        </skr-button>
        <v-spacer />
        <skr-button
          size="xl"
          color="info"
          :loading="isLoading"
          data-cy="connect_id_austria_btn"
          @click="connectIdAustria"
        >
          {{ t('global.connect') }}
        </skr-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
